import { Side } from "./index242.js";
const doubleLoadOptions = [
  { start: true, right: true, load: void 0 },
  { start: false, right: true, load: void 0 },
  { start: true, right: false, load: void 0 },
  { start: false, right: false, load: void 0 }
];
const singleLoadOptions = [
  { start: true, right: true, load: Side.right },
  { start: false, right: true, load: Side.left },
  { start: true, right: false, load: Side.right },
  { start: false, right: false, load: Side.left }
];
const ThreadOptions = {
  doubleLoadOptions,
  singleLoadOptions
};
export {
  ThreadOptions
};
//# sourceMappingURL=index246.js.map
